module.exports = __webpack_public_path__ + "static/media/extendedExperience.c0300f20.svg";